import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const Tags = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    create: "create:Tag",
    update: "update:Tag",
    list: "list:Tag",
    read: "read:Tag",
  },
};
